import { render, staticRenderFns } from "./PopupForm.vue?vue&type=template&id=fb538048"
import script from "./PopupForm.vue?vue&type=script&lang=js"
export * from "./PopupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports